import { h } from 'preact'
import { replaceFilter, tagParser } from '../../js/modules/utilities.js'
import { attributesAnalytics } from '../../js/modules/component'

export const BandeEcommerce = ({ title, items, cacheKey }) => {
   return (
      <div
         id="zone_reassurance_e-boutique"
         class="reassurance-ecommerce pb-0 pb-sm-2 my-2"
         data-testid="bande-reassurance-ecommerce"
         data-cache-key={cacheKey}
      >
         <div class="container-fluid">
            {document.body.id !== 'hp' && <h2 class="h3 block-title no-signature mb-1">{tagParser(replaceFilter(title))}</h2>}
            <ul class="reassurance-ecommerce-list">
               {items.map((item, index) => {
                  return (
                     <li>
                        <a
                           class="reassurance-ecommerce-link"
                           href={item.URL}
                           data-testid={`reassurance-ecommerce${index + 1}`}
                           {...attributesAnalytics(item.analytics)}
                        >
                           <img class="hpicon" src={`${item.image}?format=x90`} height="45" width="45" alt="" loading="lazy" />
                           <span class="reassurance-ecommerce-label o-link-arrow" dangerouslySetInnerHTML={{ __html: tagParser(replaceFilter(item.title)) }}></span>
                        </a>
                     </li>
                  )
               })}
            </ul>
         </div>
      </div>
   )
}
